import React from 'react'
import './styles.scss'
// import { useTranslation } from 'react-i18next'

export default function CompanyModal(props) {
  // const { t } = useTranslation()

  return (
    <div id="myModal" className="modal" onClick={props.close}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-display-grid">
          <div className="header">
            <span className="close" onClick={props.close}>
              &times;
            </span>
          </div>
          <div className="content">{props.children}</div>
        </div>
      </div>
    </div>
  )
}
